// Find duplicate string values in an array
export const findDuplicateStringValues = (arr: string[]): string[] => {
  const stringValues: Set<string> = new Set();
  const duplicates: Set<string> = new Set();

  for (const value of arr) {
    if (stringValues.has(value)) {
      duplicates.add(value);
    } else {
      stringValues.add(value);
    }
  }

  return Array.from(duplicates);
};

// Find duplicate values in two arrays of strings;
export const findDuplicateStringValuesFromArrays = (
  arr1: string[],
  arr2: string[]
): string[] => {
  const set1: Set<string> = new Set(arr1);
  const set2: Set<string> = new Set(arr2);
  const duplicates: Set<string> = new Set();

  for (const value of set1) {
    if (set2.has(value)) {
      duplicates.add(value);
    }
  }

  return Array.from(duplicates);
};

// Finds last index of an element in an array that satisfies the predicate
export const findLastIndex = <T>(
  array: T[],
  predicate: (value: T, index: number, array: T[]) => boolean
): number => {
  for (let i = array.length - 1; i >= 0; i--) {
    if (predicate(array[i], i, array)) {
      return i;
    }
  }
  return -1; // Return -1 if no element satisfies the predicate
};
